import React from 'react';
import { Button, Form, FormGroup, Label, Input, FormText, Container, Row, Col } from 'reactstrap';
import axios from 'axios';
import Swal from 'sweetalert2';
import buyerImg from '../img/learn1.png';
import sellerImg from '../img/share1.png';
import bgImg from '../img/talentbg.jpg';
import peopleImg from '../img/people2.png';
import logo from '../img/logo.png';

import '../index.css';
import '../styles/signup.css';

const styles = {
    background: {
        backgroundImage: 'url('+ bgImg+')'
    }
};

export default class Landing extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <React.Fragment>
                    <div className="bg">
                        <div className="header">
                            <img src={logo} className="logo"/>
                            <nav>
                                <ul>
                                    <li><a href="/#">ABOUT</a></li>
                                    <li><a href={`/signin`}>LOGIN</a></li>
                                    <li><a href="/#">CONTACT</a></li>
                                </ul>
                            </nav>
                        </div>
                        <div className="intro"> Meet Your Local Friends
                            <div>
                            To Share Skills
                            </div>
                        </div>
                    </div>
                    <div className="sectionBg">
                        <div className="box">
                            <div className="box1">
                                {/*box1*/}
                                <div className="middle">
                                    <div className="category">TRAVEL</div>
                                </div>
                            </div>
                            <div className="box2">
                                {/*box2*/}
                                <div className="middle">
                                    <div className="category">CODING</div>
                                </div>
                            </div>
                            <div className="box3">
                                {/*box3*/}
                                <div className="middle">
                                    <div className="category">MUSIC</div>
                                </div>
                            </div>
                            <div className="box4">
                                {/*box4*/}
                                <div className="middle">
                                    <div className="category">COOK</div>
                                </div>
                            </div>
                            <div className="box5 signup">
                                {/*box5*/}
                                We All Have a Skill!
                                <div>
                                    Share Your Skills and Learn Together.
                                    <br/>
                                    Join your local community today
                                    <br/>
                                    and schedule 1 on 1 hangout!
                                </div>
                                <div className="signin">
                                    <a href={`/signin`}> Already signed up? </a>
                                </div>
                                <img src={peopleImg} className="people"/>
                            </div>
                            <div className="box6">
                                {/*box6*/}
                                <div className="middle">
                                    <div className="category">PHOTOGRAPHY</div>
                                </div>
                            </div>
                            <div className="box7">
                                {/*box7*/}
                                <div className="middle">
                                    <div className="category">ART</div>
                                </div>
                            </div>
                            <div className="box8">
                                <a href="/signup/buyer">
                                    <img src={buyerImg} className="image"/>
                                    <div className="middle">
                                        <div className="text">BUYER</div>
                                    </div>
                                </a>
                            </div>
                            <div className="box9">
                                <a href="/signup/seller">
                                    <img src={sellerImg} className="image" />
                                    <div className="middle">
                                        <div className="text">SELLER</div>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                <p>Contact Me : jinju2828@gmail.com</p>
            </React.Fragment>

        );
    }
}
